<template>
  <AppLayout>
    <VFlex
      sm12
      md12
    >
      <h1 class="primary--text mb-4">
        {{ $nt('heading') }}
      </h1>
      <VCard>
        <VFlex xs12>
          <AgencyEdit />
        </VFlex>
      </VCard>
    </VFlex>
  </AppLayout>
</template>

<script>
import { mapActions } from 'vuex'
import AgencyEdit from '@/components/routes/agency/agencySettings/AgencyEdit'

export default {
  name: 'AgencySettings',
  components: { AgencyEdit },
  methods: {
    ...mapActions('agency', ['getAgency'])
  },
  created () {
    this.getAgency({})
  }
}
</script>
